import '../../Styles/ServiceTeaser/serviceTeaser.scss';

window.am = window.am || {};

window.am.serviceTeaser = new function ()
{
    var that = this;
    let serviceTeaser;

    that.setLinkButtonHeight = function ()
    {
        serviceTeaser.forEach(function (teaser)
        {
            var buttons = teaser.querySelectorAll('.service-teaser-links .col a');
            var highestButton = 0;

            if (buttons.length > 0)
            {
                buttons.forEach(function (button)
                {
                    button.style.height = 'auto';

                    if (button.offsetHeight > highestButton)
                    {
                        highestButton = button.offsetHeight;
                    }
                });

                buttons.forEach(function (button)
                {
                    button.style.height = highestButton + 'px';
                });
            }
        })
    }

    that.checkLinkButtonHeight = function ()
    {
        if (!serviceTeaser.length)
        {
            return;
        }
        that.setLinkButtonHeight();
    };

    that.init = function ()
    {
        serviceTeaser = document.querySelectorAll('.service-teaser-container');
        that.setLinkButtonHeight();
        window.addEventListener('resize', that.checkLinkButtonHeight);
    };
}

window.addEventListener("load", window.am.serviceTeaser.init);
